import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';
import logoImage from '../assets/images/Insight-Digital-Agency_LogoDesign_For-Web-01.png';
import WaveOverlay from './WaveOverlay';

const Footer = () => {
  return (
    <>
      <div className="relative bg-white py-8">
        <div className="absolute top-0 left-0 w-full z-10">
          <WaveOverlay inverted={true} color="fill-white" />
        </div>
                 <div className="absolute bottom-0 left-0 w-full z-20" style={{transform: 'translateY(10px)'}}>
          <WaveOverlay inverted={false} color="fill-gray-900" height="h-40" />
        </div>
      </div>
      <footer className="bg-gray-900 text-white">
        <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="bg-white rounded p-2 flex-shrink-0">
                <img src={logoImage} alt="Insight Digital Agency" className="h-10 w-auto object-contain" />
              </div>
              <span className="text-lg font-bold">Insight Digital Agency</span>
            </div>
            <p className="text-gray-300 text-sm">
              Your Visibility. Our Obsession.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/InsightDigitalAgency" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-orange-400 transition-colors">
                <Facebook size={20} />
              </a>
              <a href="https://www.instagram.com/InsightDigitalAgencyKC/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-orange-400 transition-colors">
                <Instagram size={20} />
              </a>
              <a href="https://www.linkedin.com/in/insightdigitalagency/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-orange-400 transition-colors">
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-300 hover:text-orange-400 transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-orange-400 transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/blogs" className="text-gray-300 hover:text-orange-400 transition-colors text-sm">
                  Blogs
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-orange-400 transition-colors text-sm">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Our Services</h3>
            <ul className="space-y-2">
              <li className="text-gray-300 text-sm">Local SEO</li>
              <li className="text-gray-300 text-sm">Reputation Management</li>
              <li className="text-gray-300 text-sm">Social Marketing</li>
              <li className="text-gray-300 text-sm">Google Business Profile</li>
              <li className="text-gray-300 text-sm">Website Development</li>
              <li className="text-gray-300 text-sm">Marketing Consultation</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Phone size={16} className="text-orange-400" />
                <a href="tel:913-513-1525" className="text-gray-300 hover:text-orange-400 transition-colors text-sm">
                  913-513-1525
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail size={16} className="text-orange-400" />
                <a href="mailto:info@insightdigitalagency.com" className="text-gray-300 hover:text-orange-400 transition-colors text-sm">
                  info@insightdigitalagency.com
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin size={16} className="text-orange-400 mt-1" />
                <span className="text-gray-300 text-sm">
                  Overland Park, KS<br />
                  Springfield, MO<br />
                  United States
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-center md:text-left space-y-1">
              <p className="text-gray-400 text-sm">
                © 2026 Insight Digital Agency. All rights reserved.
              </p>
              <p className="text-gray-500 text-xs">
                Updated May 2026.
              </p>
            </div>
            <div className="flex space-x-6">
              <Link to="/privacy" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
    </>
  );
};

export default Footer;

